/**
 * Calculates mining profit by hashrate
 * @returns object with profit in USD and BTC formats
 */
export const getMiningProfitByHashrate = (
  hashpriceUsd: number,
  hashpriceBtc: string,
  thPerSecond: number
) => {
  const phPerSecond = thPerSecond / 1000
  const profitBtc = Number(hashpriceBtc) * phPerSecond
  const profitUsd = hashpriceUsd * phPerSecond
  return {
    profitBtc,
    profitUsd,
  }
}
